import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';


function GalleryImage({
  handleshow,
  company,
  companyName,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const { preview, setPreview } = useContext(CreativeContext);
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [inputFields, setInputFields] = useState([
    {
      img_id: "",
      image: "",
      click_url: "",
      impression_url: "",
      impression_url_secondary: "",
    },
  ]);
  const [processingIndex, setProcessingIndex] = useState(-1);
  const imageChange = async (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      imageUrl(e.target.files[0], index);
      setProcessingIndex(index);
    } else {
      if (flag === "edit") {
        if (editdata.gallery[index]) {
          const values = [...inputFields];
          values[index].image = editdata.gallery[index].image;
          setInputFields(values);
          const { img_urls } = preview;
          img_urls[index] = editdata.gallery[index]?.image;
          setPreview({ ...preview, img_urls: img_urls });
        }
        else {
          setProgress(0);
          setValue(`image${index}`, "");
          const values = [...inputFields];
          values[index].image = "";
          setInputFields(values);
          const { img_urls } = preview;
          img_urls[index] = "";
          setPreview({ ...preview, img_urls: img_urls });
        }
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        const values = [...inputFields];
        values[index].image = "";
        setInputFields(values);
        const { img_urls } = preview;
        img_urls[index] = "";
        setPreview({ ...preview, img_urls: img_urls });
      }


    };
  }
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  let watchshuffle = watch("shuffle");
  let watchMagazine = watch('magazine_ads')
  let watchPdf = watch('ispdf', '1')
  if (flag === "edit") {
    watchshuffle = watch("shuffle", editdata.shuffle === 1 ? true : false);
    watchMagazine = watch("magazine_ads", editdata.center === 1 ? true : false)
    watchPdf = watch('ispdf', editdata.video_urls  ? '2' : '1')
  }
  const imageUrl = async (imgFile, index) => {
    try {
      const formData = new FormData();
      formData.append("files", imgFile);
      let url = await api({
        url: `/upload/image`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        let values = [...inputFields];
        values[index].image = url.data.data;
        values[index].img_id = `${index}`;
        setInputFields(values);
        const { img_urls } = preview;
        img_urls[index] = url.data.data;
        setPreview({ ...preview, img_urls: img_urls });
      } else {
        setProgress(0)
        setValue(`image${index}`, "");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (flag === "edit") {
      const data = JSON.parse(JSON.stringify(editdata.gallery));
      setInputFields(data);
      let img_urls = [];
      editdata.gallery.map((ele) => img_urls.push(ele.image));
      setPreview({
        ...preview,
        img_urls: img_urls,
      });
    }
  }, [company]);

  const handleAdd = () => {
    if ((watchMagazine && inputFields.length < 20 ) || (!watchMagazine &&  inputFields.length < 10)) {
      setInputFields([
        ...inputFields,
        {
          image: "",
          click_url: "",
          impression_url: "",
          impression_url_secondary: ""
        },
      ]);
      const { img_urls } = preview;
      img_urls.push("");
    } else {

      if(watchMagazine && inputFields.length >= 20)
      Toast("error", "For magazine ones only limit of 20 Images accepted");
      else
      Toast("error", "Maximum limit of 10 Images exceeded");
    }
  };

  const handleRemove = (index) => {
    setValue(`image${index}`, "");
    const values = [...inputFields];
    values.splice(index, 1);
    if (editdata.gallery && editdata.gallery[index]) {
      editdata.gallery.splice(index, 1);
    }
    setInputFields(values);
    const { img_urls } = preview;
    img_urls.splice(index, 1);
    setPreview({ ...preview, img_urls: img_urls });
  };

  const handleClickUrl = (index, event) => {
    const values = [...inputFields];
    values[index].click_url = event.target.value;
    setInputFields(values);
  };
  const handleImpUrl = (index, event) => {
    const values = [...inputFields];
    values[index].impression_url = event.target.value;
    setInputFields(values);
  };
  const handleImpUrl2 = (index, event) => {
    const values = [...inputFields];
    values[index].impression_url_secondary = event.target.value;
    setInputFields(values);
  };

  const onSubmit = async (event) => {
    if (inputFields.length < 2) {
      Toast("error", "Minimum 2 Images required");
    } else {
      if (flag === "edit") {
        let obj = {
          creative_name: creative_name,
          creative_id: editdata.creative_id,
          inputFields: inputFields.map((obj1) => {
            return {
              img_id: parseInt(obj1.img_id),
              image: obj1.image,
              click_url: obj1.click_url,
              impression_url: obj1.impression_url,
              impression_url_secondary: obj1.impression_url_secondary
            };
          }),
          shuffle: watchshuffle,
          magazine_ads:watchMagazine,
          isPdf:watchMagazine ? watchPdf : undefined
        };
        try {
          let res = await api({
            url: `/creatives/image/editgalleryimage`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative edited Successfull  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);

          }
        } catch (error) {
          navigate("/");
        }
      } else {
        let obj = {
          company_id: company,
          company_name: companyName,
          // adv_id: advId,
          creative_name,
          creative_type,
          sub_type: subtype,
          inputFields: inputFields.map((obj1) => {
            return {
              img_id: parseInt(obj1.img_id),
              image: obj1.image,
              click_url: obj1.click_url,
              impression_url: obj1.impression_url,
              impression_url_secondary: obj1.impression_url_secondary
            };
          }),
          shuffle: watchshuffle,
          magazine_ads:watchMagazine,
          isPdf:watchMagazine ? watchPdf : undefined
        };
        handlesubmit(true);
        // if (advId !== "" && creative_name !== "") {
        if (creative_name !== "") {
          try {
            let res = await api({
              url: `/creatives/image/galleryimage`,
              method: "POST",
              responseType: "json",
              data: obj,
            });
            if (res?.code === 200) {
              Toast("success", " Creative Successfull  ");
              handleshow(false);
              createdEdited(true);
            } else {
              Toast("error", res.data.message);

            }
          } catch (error) {
            navigate("/");
          }
        }
      }
    }
  };
  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)}>
          <button
            type="button"
            name="add"
            className="btn btn-primary"
            onClick={() => handleAdd()}
          >
            Add
          </button>
          {inputFields.map((inputField, index) => (
            <div key={index}>
              <div className="mb-3">
                <label className="form-label">Image</label><br />
                <span>(Image height should be greater than width  )</span>
                <input
                  className="form-control mb-2"
                  type="file"
                  id="formFile"
                  name="files"
                  {...register(`image${index}`, {
                    required: inputFields[index].image !== "" ? false : true,
                    onChange: (e) => imageChange(e, index),
                  })}
                />
                {errors[`image${index}`] && (
                  <p className="text-red-600">Image is mandatory</p>
                )}
                {processingIndex === index && progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> :
                  inputFields[index].image !== "" ? (
                    <span>{`${inputField.image}`}</span>
                  ) : (
                    flag === "edit" && <span>{`${inputField.image}`}</span>
                  )}
              </div>

              <div className="row mb-3 align-items-end">
                <div className="col">
                  <label className="form-label">Click URL / Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={flag === "edit" ? inputField.click_url : ""}
                    {...register(`click_url${index}`, {
                      required: false,
                      onChange: (e) => handleClickUrl(index, e),
                      pattern: {
                        value:
                        /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                        message: "Enter a Valid URL or Mobile Number",
                      },
                    })}
                  />
                  {errors[`click_url${index}`] && (
                    <p style={{ color: "red" }}>
                      {errors[`click_url${index}`].message}
                    </p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      flag === "edit" ? inputField.impression_url : ""
                    }
                    {...register(`impression_url${index}`, {
                      required: false,
                      onChange: (e) => handleImpUrl(index, e),
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors[`impression_url${index}`] && (
                    <p style={{ color: "red" }}>
                      {errors[`impression_url${index}`].message}
                    </p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Secondary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      flag === "edit" ? inputField.impression_url_secondary : ""
                    }
                    {...register(`impression_url_secondary${index}`, {
                      required: false,
                      onChange: (e) => handleImpUrl2(index, e),
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors[`impression_url_secondary${index}`] && (
                    <p style={{ color: "red" }}>
                      {errors[`impression_url_secondary${index}`].message}
                    </p>
                  )}
                </div>
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => handleRemove(index)}
                  >
                    {" "}
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={watchshuffle}
              {...register("shuffle", { required: false })}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              shuffle
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={watchMagazine}
              {...register("magazine_ads", { required: false })}
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              Magazine ads
            </label>
          </div>
          {console.log(watchMagazine)}
          {
            watchMagazine && (
              <div className="mt-3">
                         <label className="form-label">Share Type</label>
                         <br></br>
                         <div class="form-check form-check-inline">
                           <input
                             class="form-check-input"
                             type="radio"
                             checked={'1' === watchPdf}
                             {...register("ispdf", { required: watchMagazine })}
                             id="Image"
                             value="1"
                           />
                           <label class="form-check-label" for="Image">
                             Image
                           </label>
                         </div>
                         <div class="form-check form-check-inline">
                           <input
                             class="form-check-input"
                             type="radio"
                             {...register("ispdf", { required: watchMagazine })}
                             id="Pdf"
                             checked={'2' === watchPdf}
                             value="2"
                           />
                           <label class="form-check-label" for="Pdf">
                             Pdf
                           </label>
                         </div>
                         <br></br>
                         {errors.ispdf && <p className="text-red-500">{'Please choose share type'}</p>}
                       </div>
            )
          }
          <section className="col-12">
            <div className="my-3 text-end">
              <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) ? true : false}>
                Save Creative
              </button>
            </div>
          </section>
        </form>
      </div>
    </>
  );
}

export default GalleryImage;
